import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router-dom';
import Helmet from '../services/reactHelmetClient';
import Dashboard from './Dashboard/';
import Header from './Global/Header';
import Home from './Home';
import SelectSite from './SelectSite';
import Profile from './Profile';
import Admin from './Admin';
import Contact from './Contact';

class Routes extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>Page Outil: Google Search Console Optimization</title>
          <meta
            name="description"
            content="Looking to get the most out of your Google Search Console optimization? Try out Page Outil today to take full advantage of your GSC data."
          />
        </Helmet>
        <Header />
        <Route exact path="/" component={Home} />
        <Route path="/dashboard" component={Dashboard} />
        {/* <Route path="/dashboard" render={() => (
          this.props.auth ? <Dashboard /> : <Redirect to="/" component={Home} />
        )}/> */}
        <Route path="/setup" component={SelectSite} />
        <Route path="/profile" component={Profile} />
        <Route path="/admin" component={Admin} />
        <Route path="/contact" component={Contact} />
      </div>
    );
  }
};

function mapStateToProps({ auth }) {
  return { auth };
}

export default withRouter(connect(mapStateToProps)(Routes));



// WEBPACK FOOTER //
// ./src/components/Routes.js